import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  changeStatusBtn: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
  },
  truncate: {
    display: '-webkit-box',
    '-webkit-line-clamp': 4,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  title: {
    color: theme.palette.general.grey,
    fontSize: theme.typography.pxToRem(24),
    marginLeft: 5,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

export default useStyles;
